import { render, staticRenderFns } from "./image-text-list.vue?vue&type=template&id=8cfe7b20&scoped=true&"
import script from "./image-text-list.vue?vue&type=script&lang=js&"
export * from "./image-text-list.vue?vue&type=script&lang=js&"
import style0 from "./image-text-list.vue?vue&type=style&index=0&id=8cfe7b20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cfe7b20",
  null
  
)

export default component.exports